import React, { useEffect, useState } from "react";
import axios from "axios";
import "./deleteCat.css";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    imageUrl: "",
  });
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://api.swasthmitra.com/api/category/get"
        );
        setCategories(response.data.categories);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch categories. Please try again later.");
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const deleteCategory = async (id) => {
    try {
      await axios.delete(`https://api.swasthmitra.com/api/category/delete/${id}`);
      setCategories(categories.filter((category) => category._id !== id));
    } catch (err) {
      setError("Failed to delete category. Please try again later.");
    }
  };

  const openEditModal = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      description: category.description || "",
      imageUrl: category.imageUrl,
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingCategory(null);
    setImageFile(null);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const updateCategory = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("description", formData.description);
      if (imageFile) {
        formDataToSend.append("image", imageFile);
      }
      console.log(formDataToSend);

      await axios.put(
        `https://api.swasthmitra.com/api/category/updateCatagory/${editingCategory._id}`,
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setCategories(
        categories.map((cat) =>
          cat._id === editingCategory._id
            ? {
                ...cat,
                ...formData,
                imageUrl: imageFile
                  ? URL.createObjectURL(imageFile)
                  : cat.imageUrl,
              }
            : cat
        )
      );
      closeModal();
    } catch (err) {
      setError("Failed to update category. Please try again later.");
    }
  };

  if (loading) return <p>Loading categories...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center" }}>Categories</h1>
      <div className="gd-main">
        {categories.map((category) => (
          <div
            key={category._id}
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={category.imageUrl}
              alt={category.name}
              className="img-cat"
            />
            <div style={{ padding: "15px" }}>
              <h3 style={{ margin: "0 0 10px", fontSize: "13px" }}>
                {category.name}
              </h3>
              <p style={{ color: "#555", fontSize: "9px" }}>
                {category.description || "No description available."}
              </p>
              <button
                onClick={() => deleteCategory(category._id)}
                style={{
                  backgroundColor: "red",
                  color: "#fff",
                  padding: "5px 10px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "5px",
                }}
              >
                Delete
              </button>
              <button
                onClick={() => openEditModal(category)}
                style={{
                  backgroundColor: "blue",
                  color: "#fff",
                  padding: "5px 10px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Edit
              </button>
            </div>
          </div>
        ))}
      </div>
      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Category</h2>
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            <label>Description:</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
            />
            <label>Image:</label>
            <input type="file" name="image" onChange={handleImageChange} />
            <button onClick={updateCategory}>Update</button>
            <button onClick={closeModal} className="close-btn">
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryList;
